import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from '@sine/auth-client';
import { TeamSwitcherProvider } from '@sine/sine-team-switcher';
import { NotificationProvider } from '@sine/sine-ui-components';

import App from './App';
import Pendo from './components/Pendo/Pendo';
import { DeviceContextProvider } from './external/device';
import GoogleMapsLoader from './external/google-maps/GoogleMapsLoader';
import { queryClient } from './query.client';
import authService from './services/auth/auth.service';
import deviceService from './services/auth/device.service';
import NewRelicProvider from './services/file/NewRelicProvider';
import notificationService from './services/notification/notification.service';
import teamSwitcherService from './services/team/teamSwitcher.service';
import IntercomProvider from './shared/providers/IntercomProvider';
import LaunchDarklyProvider from './shared/providers/launchdarkly.context';
import PermissionsProvider from './shared/providers/permissions.provider';
import GlobalStyles from './theme/GlobalStyles';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleMapsLoader />
    <GlobalStyles />
    <NotificationProvider notificationService={notificationService}>
      <DeviceContextProvider deviceServiceInstance={deviceService}>
        <AuthProvider authService={authService}>
          <TeamSwitcherProvider teamSwitcherService={teamSwitcherService}>
            <QueryClientProvider client={queryClient}>
              <IntercomProvider>
                <LaunchDarklyProvider>
                  <NewRelicProvider>
                    <BrowserRouter basename={window.env.PUBLIC_URL}>
                      <PermissionsProvider>
                        <Pendo />
                        <App />
                      </PermissionsProvider>
                    </BrowserRouter>
                  </NewRelicProvider>
                </LaunchDarklyProvider>
              </IntercomProvider>
            </QueryClientProvider>
          </TeamSwitcherProvider>
        </AuthProvider>
      </DeviceContextProvider>
    </NotificationProvider>
  </StrictMode>,
);
